// extracted by mini-css-extract-plugin
export default {"headmDiv":"Header_headmDiv__+-A04","imgTag":"Header_imgTag__Vb3T7","overlay":"Header_overlay__ep3B2"};